/* USERS */
export const GET_BULK_LIST = "GET_BULK_LIST"
export const GET_BULK_LIST_SUCCESS = "GET_BULK_LIST_SUCCESS"
export const GET_BULK_LIST_FAIL = "GET_BULK_LIST_FAIL"
export const GET_BULK_DELIVERY_LIST = "GET_BULK_DELIVERY_LIST"
export const GET_BULK_LIST_DELIVERY_SUCCESS = "GET_BULK_LIST_DELIVERY_SUCCESS"
export const GET_BULK_LIST_DELIVERY_FAIL = "GET_BULK_LIST_DELIVERY_FAIL"
export const GET_BULK_LIST_DETAIL = "GET_BULK_LIST_DETAIL"
export const GET_BULK_LIST_DETAIL_SUCCESS = "GET_BULK_LIST_DETAIL_SUCCESS"
export const GET_BULK_SCHEDULE = "GET_BULK_SCHEDULE"
export const GET_BULK_SCHEDULE_SUCCESS = "GET_BULK_SCHEDULE_SUCCESS"
export const GET_BULK_SCHEDULE_FAIL = "GET_BULK_SCHEDULE_FAIL"
export const SEND_BULK_SMS = "SEND_BULK_SMS"
export const SEND_BULK_SMS_SUCCESS = "SEND_BULK_SMS_SUCCESS"
export const SEND_BULK_SMS_FAIL = "SEND_BULK_SMS_FAIL"
export const SEND_QUICK_SMS = "SEND_QUICK_SMS"
export const SEND_QUICK_SMS_SUCCESS = "SEND_QUICK_SMS_SUCCESS"
export const SEND_QUICK_SMS_FAIL = "SEND_QUICK_SMS_FAIL"
export const UPDATE_SENT_SMS = "UPDATE_SENT_SMS"